import store from '@/app/store/store';
import HELPER from '@/app/utils/HELPER';
import utils from '@/app/utils/gfUtils';
import { allAtomsIntegration } from '@/app/editor/sidebar/interactions/configs/atom';
import { template } from '@/app/editor/sidebar/templates/designOptions.html';
import { checkKeyValid } from '@/app/utils/checkRoleApply';
import { renderTabDesign } from '@/app/editor/sidebar/global-style/renderTabDesign';
import { renderTabSettings } from './global-style/renderTabSetting';
import { app } from '@/store';
import { SPACING_DATA_KEY } from '@modules/editor-sidebar';
import { handleElementAttrChanged } from '@/modules/gem-meter';
import { debounce } from '@modules/common';

export const keyCurrentSettingTab = '__currentSettingTab';

(function (jQuery) {
  jQuery.gfTabs = function (element, options) {
    const defaults = {
      targetElement: undefined,
      onTabClick: function (tabName) {},
      onSettingsChanged: function () {},
    };

    this.settings = {};
    const $element = jQuery(element);

    const _this = this;

    let $designOptions;
    let $styleEditor;

    let _designOptionsClick = false;

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');
    const $gfResTool = jQuery('#gfResTool');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();

    // Set Responsive
    const screenType =
      $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';
    let _iconButtonReponsive;
    switch (screenType) {
      case 'lg':
        _iconButtonReponsive = utils.svgIcon('desktop');
        break;
      case 'md':
        _iconButtonReponsive = utils.svgIcon('laptop');
        break;
      case 'sm':
        _iconButtonReponsive = utils.svgIcon('tablet');
        break;
      case 'xs':
        _iconButtonReponsive = utils.svgIcon('phone');
        break;
    }

    const _designOptions = template({
      iconButtonResponsive: _iconButtonReponsive,
    });

    let $targetElement;

    let _merPos = {
      merId: 0,
      tabIndex: 0,
      scrollTopSetting: 0,
      scrollTopDesign: 0,
    };

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);

      $element
        .children('ul.simple-tabs-item')
        .children('li')
        .children('a')
        .off('click')
        .on('click', function (e) {
          e.stopPropagation();
          e.preventDefault();

          // Get clicked index
          const $li = jQuery(this).parent();
          const index = $li.index();

          if (!$li.hasClass('active')) {
            _this.gotoTab(index);
          }

          // Update merPost tabIndex khi thay đổi tab;
          _merPos.tabIndex = index;
          let scrollTop = _merPos.scrollTopSetting;
          if (_merPos.tabIndex == 1) {
            scrollTop = _merPos.scrollTopDesign;
          }
          $element.find('.md-body').eq(_merPos.tabIndex).data('optiscroll').scrollTo(false, scrollTop, 0);

          return false;
        });
      // set target element
      _this.setTargetElement(_this.settings.targetElement);

      $element.find('.md-body.design-panel').html(_designOptions);

      $designOptions = $element.find('.md-body.design-panel').children('.design-options');

      // optiscroll
      const bodyHeight = jQuery(window).height() - $gfLeftSideBar.find('.md-title').height() - 50 - 20 - 29;
      $element.find('.md-body').addClass('optiscroll').optiscroll();

      if ($targetElement.attr('data-label') == undefined) {
        var $targetEl = $targetElement.closest('[data-label]');
      } else {
        var $targetEl = $targetElement;
      }

      // new InteractionPanel($targetEl);

      // Hide Integration if atom not support
      if ($targetEl) {
        let atomLabel = '';
        if ($targetEl.data('gfrow') != undefined) {
          atomLabel = $targetEl.data('gfrow').getRowName();
        } else if ($targetEl.data('gfmodule') != undefined) {
          atomLabel = $targetEl.data('gfmodule').getModuleName();
        } else if ($targetEl.data('gfelement')) {
          atomLabel = $targetEl.data('gfelement').getElementName();
        }

        const atom = allAtomsIntegration.get(atomLabel);
        if (!atom) {
          $designOptions.find('.columns[data-caption=Interactions]').remove();
        }
      }

      const merId = $targetEl.attr('id');

      if (merId == _merPos.merId) {
        _this.gotoTab(_merPos.tabIndex);

        let scrollTop = _merPos.scrollTopSetting;
        if (_merPos.tabIndex == 1) {
          scrollTop = _merPos.scrollTopDesign;
        }
        $element.find('.md-body').eq(_merPos.tabIndex).data('optiscroll').scrollTo(false, scrollTop, 0);

        if (_merPos.tabIndex == 1) {
          const noTimeout = true;
          _this.onDesignOptionsTabClick(noTimeout);
        }
      } else {
        // go to first tab by default
        _this.gotoTab(0);
        _merPos = {
          merId: merId,
          tabIndex: 0,
          scrollTopSetting: 0,
          scrollTopDesign: 0,
        };
      }

      // event optiscroll
      $element.find('.md-body').on('scrollstart', function (ev) {
        $gfLeftSideBar.data('gfleftsidebar').onBackgroundIframe('leftSideBarBodyElement');
      });

      $element
        .find('.md-body')
        .off('mouseup.scroll')
        .on('mouseup.scroll', function (ev) {
          $gfLeftSideBar.data('gfleftsidebar').offBackgroundIframe('leftSideBarBodyElement');
        });

      let delayScrollTimeout;
      $element.find('.md-body').on('scrollstop', function (ev) {
        $gfLeftSideBar.data('gfleftsidebar').offBackgroundIframe('leftSideBarBodyElement');

        clearTimeout(delayScrollTimeout);
        delayScrollTimeout = setTimeout(function () {
          const scrollTop = ev.detail.scrollTop;

          // Khi scroll cập nhật lại merPos scrollTop
          const tabName = _this.getCurrentTab();
          switch (tabName) {
            case 'Settings':
              _merPos.scrollTopSetting = scrollTop;
              break;

            case 'Design':
              _merPos.scrollTopDesign = scrollTop;
              break;
          }
        }, 10);
      });

      $element.off('screen-mode-change').on('screen-mode-change', function () {
        const tabName = _this.getCurrentTab();
        _this.settings.onTabClick(tabName);
        return false;
      });

      // BIND INPUT CHANGE
      _this.bindInputChange();

      $element.off('mouseenter').on('mouseenter', function () {
        if ($targetElement) {
          if ($targetElement.data('gfrow') != undefined) {
            $targetElement.data('gfrow').showTool();
          } else if ($targetElement.data('gfmodule') != undefined) {
            $targetElement.data('gfmodule').showTool();
          } else if ($targetElement.data('gfelement') != undefined) {
            $targetElement.data('gfelement').showTool(undefined, false);
          } else if ($targetElement.closest('[data-label]').data('gfelement') != undefined) {
            $targetElement.closest('[data-label]').data('gfelement').showTool(undefined, false);
          }
        }
        return false;
      });

      $element.off('mouseleave').on('mouseleave', function () {
        if ($targetElement) {
          if ($targetElement.data('gfrow') != undefined) {
            $targetElement.data('gfrow').hideTool();
          } else if ($targetElement.data('gfmodule') != undefined) {
            $targetElement.data('gfmodule').hideTool();
          } else if ($targetElement.data('gfelement') != undefined) {
            $targetElement.data('gfelement').hideTool();
          } else if ($targetElement.closest('[data-label]').data('gfelement') != undefined) {
            $targetElement.closest('[data-label]').data('gfelement').hideTool();
          }
        }
      });
      _this.initTemplate();
      return false;
    };

    this.initTemplate = function () {
      renderTabDesign.initTemplate(_this.getTargetElement());
    };

    this.initGlobalStyle = function () {
      renderTabDesign.initSettingGlobalStyle();
    };

    this.bindInputChange = function () {
      const $settingOptions = $element.find('.settings-panel, .general-panel');
      if (checkKeyValid('atomHistory')) {
        $settingOptions.find('input, select, textarea').on('history-input-change', function () {
          const $input = jQuery(this);
          //TRUONGNC
          _this.settings.onSettingsChanged($input, 'history');
        });
      }
      const tabName = _this.getCurrentTab();
      $settingOptions.find('input, select, textarea').on('input-change', function () {
        const $input = jQuery(this);
        const dataKey = $gfLeftSideBar.find('#md-settings').find('.md-title .mer-title').attr('data-key');
        const isInputGS = renderTabSettings.checkInputGlobalStyle(dataKey, $input);
        if (!isInputGS) {
          _this.settings.onSettingsChanged($input);
          renderTabSettings.triggerSelectRenderGS($input, dataKey);
        }
        renderTabDesign.setTargetElement(_this.getTargetElement());
        debounce(() => {
          handleElementAttrChanged(`${_merPos.merId.substring(2)}`, $input.attr('name'));
        })();
      });

      $settingOptions.find('input, select, textarea').on('history-change', function (event, extra) {
        const $this = jQuery(this);

        const merId = $gfLeftSideBar.find('#md-settings').data('edittingID');
        setTimeout(function () {
          $gryffEditor.data('gfhistory').addHistory('setting', merId, extra);
          $gryffEditor.data('gfhistory').captureMERSettings();
        }, 50);

        // Add to gfCount
        let label = $targetElement.attr('data-label');
        if (!label) {
          const $mer = $targetElement.closest('[data-label]');
          label = $mer.attr('data-label');
        }
        const extraCount = {
          label: label,
          name: $this.attr('name'),
          value: $this.attr('value'),
        };
        if ($gryffEditor && $gryffEditor.data('gfcount') != undefined) {
          $gryffEditor.data('gfcount').add('setting', extraCount);
        }
      });

      $designOptions.find('input, select, textarea').on('input-change gs-input-change', function (event) {
        let attr = jQuery(this).attr('data-name');
        if (attr) {
          let value = jQuery(this).attr('value');

          const flag = true;

          // catch box-shadow case
          if (attr.indexOf('box-shadow') !== -1) {
            const angle = $designOptions.find('[name="box-shadow-angle"]').val();
            const distance = $designOptions.find('[name="box-shadow-distance"]').val();
            const radian = angle * (Math.PI / 180);
            let x = Math.cos(radian) * parseFloat(distance);
            let y = Math.sin(radian) * parseFloat(distance);
            if (x == undefined || x == '') {
              x = '0';
            }
            if (y == undefined || y == '') {
              y = '0';
            }

            let blur = parseInt($designOptions.find('[name="box-shadow-blur"]').val());
            if (blur == undefined || blur == '') {
              blur = 0;
            }
            let spread = parseInt($designOptions.find('[name="box-shadow-spread"]').val());
            if (spread == undefined || spread == '') {
              spread = 0;
            }
            let color = jQuery.trim($designOptions.find('[name="box-shadow-color"]').val());
            if (color == undefined || color == '') {
              color = 'transparent';
            }
            let type = jQuery.trim($designOptions.find('[name="box-shadow-type"]').val());
            if (type == undefined || type == '') {
              type = 'outset';
            }

            // css box-shadow
            attr = 'box-shadow';
            value = {
              x: x,
              y: y,
              blur: blur,
              spread: spread,
              color: color,
              type: type,
            };
          }

          /**
           * gravity
           */
          if (attr == 'v-gravity' || attr == 'v-offset') {
            //get position
            const vGraviry = $designOptions.find('#v-gravity').val();
            const vOffset = $designOptions.find('#v-offset').val();
            attr = vGraviry;
            value = vOffset;
          }
          if (attr == 'h-gravity' || attr == 'h-offset') {
            //get position
            const vGraviry = $designOptions.find('#h-gravity').val();
            const vOffset = $designOptions.find('#h-offset').val();
            attr = vGraviry;
            value = vOffset;
          }
          //đề phòng lỗi nên kiểm tra lại attr
          if (!attr) {
            return;
          }

          let style = '';
          let $tempTargetElement = $targetElement;
          if ($targetElement.data('gfmodule') != undefined) {
            style = $targetElement.data('gfmodule').getModuleCSS();
          } else if ($targetElement.data('gfelement') != undefined) {
            style = $targetElement.data('gfelement').getElementCSS();
          } else if ($targetElement.data('gfrow') != undefined) {
            style = $targetElement.data('gfrow').getRowCSS();
          } else if ($targetElement.hasClass('gf_column')) {
            const colId = $targetElement.attr('data-id');
            style = $targetElement.parent().data('gfrow').getColCSS(colId);

            $tempTargetElement = $targetElemen.parent();
          } else {
            if ($targetElement.closest('.element-wrap').length > 0) {
              if ($targetElement.closest('.element-wrap').data('gfelement') != undefined) {
                style = $targetElement.closest('.element-wrap').data('gfelement').getElementCSS();

                $tempTargetElement = $targetElement.closest('.element-wrap');
              }
            } else if ($targetElement.closest('.module-wrap').length > 0) {
              if ($targetElement.closest('.module-wrap').data('gfmodule') != undefined) {
                style = $targetElement.closest('.module-wrap').data('gfmodule').getModuleCSS();

                $tempTargetElement = $targetElement.closest('.module-wrap');
              }
            }
          }

          _this.runStyle(style, attr, value);
          debounce(() => {
            handleElementAttrChanged(`${_merPos.merId.substring(2)}`, attr);
          })();

          if (flag && event.type != 'gs-input-change') {
            HELPER.flagListItemChange($tempTargetElement, 'design-options');

            if (HELPER.isInsideTheList($tempTargetElement)) {
              var $itemContent = $tempTargetElement.closest('.item-content');

              HELPER.detectContentChange($itemContent);
            }

            //hotfix trường hợp item thay đổi position trong Product thì yêu cầu Product cập nhật lại bk content
            if (attr == 'position') {
              HELPER.flagListItemChange($tempTargetElement, 'settings');
              var $itemContent = $tempTargetElement.closest('.item-content');

              HELPER.detectContentChange($itemContent);
            }
          }
        }
      });

      $designOptions.find('input, select, textarea').on('history-change', function (event, extra) {
        const $this = jQuery(this);

        const merId = $gfLeftSideBar.find('#md-settings').data('edittingID');
        setTimeout(function () {
          if (!$this.attr(SPACING_DATA_KEY)) {
            $gryffEditor.data('gfhistory').addHistory('design-option', merId, extra);
            $gryffEditor.data('gfhistory').captureMERSettings();
          }
        }, 50);

        // Add to gfCount
        let label = $targetElement.attr('data-label');
        if (!label) {
          const $mer = $targetElement.closest('[data-label]');
          label = $mer.attr('data-label');
        }
        const extraCount = {
          label: label,
          name: $this.attr('name'),
          value: $this.attr('value'),
        };
        if ($gryffEditor && $gryffEditor.data('gfcount') != undefined) {
          $gryffEditor.data('gfcount').add('design', extraCount);
        }
      });

      return false;
    };

    this.getTargetElement = function () {
      return $targetElement;
    };

    this.setTargetElement = function ($object) {
      $targetElement = $object;
    };

    this.getCurrentTab = function () {
      const $currentTab = $element.children('ul.simple-tabs-item').children('li.active').children('a');
      return jQuery.trim($currentTab.text());
    };

    this.gotoTab = function (index) {
      $element.children('ul.simple-tabs-item').children('li').removeClass('active');

      const $currentTab = $element.children('ul.simple-tabs-item').children('li').eq(index).addClass('active');

      $element.children('.md-body').removeClass('active');
      $element.children('.md-body').eq(index).addClass('active');

      // trigger tab click
      const tabName = _this.getCurrentTab();
      _this.settings.onTabClick(tabName);

      //Close background gfFrameWrap;
      if ($gfLeftSideBar.data('gfleftsidebar')) {
        $gfLeftSideBar.data('gfleftsidebar').offAllBackgroundIframe();
      }
      switch (tabName) {
        case 'Settings':
          $element.find('.settings-panel, .general-panel').gfForm();
          break;

        case 'Design':
          $element.find('.design-panel').gfForm();
          break;
      }

      //add store current tab
      store.setValue(keyCurrentSettingTab, index);

      return false;
    };

    this.closeTab = function (index) {
      const $currentTab = $element.children('ul.simple-tabs-item').children('li').eq(index);
      $currentTab.removeClass('active');
      $currentTab.children('.md-body').removeClass('active');

      return false;
    };

    this.onDesignOptionsTabClick = function (noTimeout) {
      if (noTimeout === undefined) {
        noTimeout = false;
      }

      _designOptionsClick = true;

      if (noTimeout) {
        _this.getDesignOptions();
      } else {
        setTimeout(function () {
          _this.getDesignOptions();
        }, 100);
      }
      return false;
    };

    this.runStyle = function (style, attr, value) {
      if (_designOptionsClick === true) {
        const screenType =
          $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';
        const deOptions = _this.getDesignOptionsByAttr(attr, value);

        const label = $targetElement.attr('data-label');

        switch (label) {
          case '(P) Variants':
          case '(P) Title':
          case '(P) Vendor':
          case '(P) SKU':
          case '(P) Description':
          case '(P) Price':
          case '(P) Quantity':
          case '(P) Cart Button':
          case '(P) Dynamic Checkout Button':
          case '(P) View More':
          case '(P) Image':
          // case '(P) Image List':
          case '(P) Variants':
          case '(P) Swatches':
          case '(P) Meta':
          case '(P) File Upload':

          case '(A) Title':
          case '(A) Image':
          case '(A) Content':
          case '(A) Excerpt':
          case '(A) Date':

          // social share has child items
          case 'Social Share':
            var moduleClass = $targetElement.data('gfmodule').getTargetClass();
            var $self = $targetElement.find(moduleClass);
            break;

          default:
            var $self = $targetElement;
            break;
        }

        style = HELPER.designOptions2Style($self, screenType, style, deOptions);
        /**
         * support position
         *
         */
        if (attr == 'position') {
          style = this.supportPosition(style, attr, value, $self, label);
        }
        if (attr == 'top' || attr == 'bottom' || attr == 'left' || attr == 'right') {
          style = this.supportGravity(style, attr, value, $self, screenType);
        }

        if ($targetElement.data('gfmodule') !== undefined) {
          $targetElement.data('gfmodule').runStyle(style);
        } else if ($targetElement.data('gfelement') !== undefined) {
          $targetElement.data('gfelement').runStyle(style);
        } else if ($targetElement.data('gfrow') !== undefined) {
          $targetElement.data('gfrow').runStyle(style);
        } else if ($targetElement.hasClass('gf_column')) {
          $targetElement.parent().data('gfrow').runColumnStyle($targetElement, style);
        } else {
          const $targetElementWrap = $targetElement.closest('.element-wrap');
          const $targetModuleWrap = $targetElement.closest('.module-wrap');
          if ($targetElementWrap.length > 0 && $targetElementWrap.data('gfelement')) {
            $targetElementWrap.data('gfelement').runStyle(style);
          } else if ($targetModuleWrap.length > 0 && $targetModuleWrap.data('gfmodule')) {
            $targetModuleWrap.data('gfmodule').runStyle(style);
          }
        }
      }
      return false;
    };

    this.getDesignOptions = function () {
      let tgrClass = '';
      if ($targetElement.data('gfelement') != undefined) {
        tgrClass = $targetElement.data('gfelement').getTargetClass();
      }

      const $display = $element.find('input[name="display"]'),
        // margin
        $marginTop = $element.find('input[name="margin-top"]'),
        $marginRight = $element.find('input[name="margin-right"]'),
        $marginBottom = $element.find('input[name="margin-bottom"]'),
        $marginLeft = $element.find('input[name="margin-left"]'),
        // padding
        $paddingTop = $element.find('input[name="padding-top"]'),
        $paddingRight = $element.find('input[name="padding-right"]'),
        $paddingBottom = $element.find('input[name="padding-bottom"]'),
        $paddingLeft = $element.find('input[name="padding-left"]'),
        // background
        $backgroundColor = $element.find('input[name="background-color"]'),
        $backgroundImage = $element.find('input[name="background-image"]'),
        $backgroundSize = $element.find('[name="background-size"]'),
        $backgroundRepeat = $element.find('[name="background-repeat"]'),
        $backgroundPosition = $element.find('[name="background-position"]'),
        $backgroundAttachment = $element.find('[name="background-attachment"]'),
        // shadow
        $boxShadowColor = $element.find('input[name="box-shadow-color"]'),
        $boxShadowAngle = $element.find('input[name="box-shadow-angle"]'),
        $boxShadowDistance = $element.find('input[name="box-shadow-distance"]'),
        $boxShadowBlur = $element.find('input[name="box-shadow-blur"]'),
        $boxShadowSpread = $element.find('input[name="box-shadow-spread"]'),
        $boxShadowType = $element.find('input[name="box-shadow-type"]'),
        $boxShadowStyle = $element.find('input[name="box-shadow-style"]'),
        // border

        $borderWidth = $element.find('input[name="border-width"]'),
        $borderTop = $element.find('input[name="border-top-width"]'),
        $borderRight = $element.find('input[name="border-right-width"]'),
        $borderBottom = $element.find('input[name="border-bottom-width"]'),
        $borderLeft = $element.find('input[name="border-left-width"]'),
        $borderStyle = $element.find('input[name="border-style"]'),
        $borderColor = $element.find('input[name="border-color"]'),
        $borderRadius = $element.find('input[name="border-radius"]'),
        $borderTopLeftRadius = $element.find('input[name="border-top-left-radius"]'),
        $borderTopRightRadius = $element.find('input[name="border-top-right-radius"]'),
        $borderBottomLeftRadius = $element.find('input[name="border-bottom-left-radius"]'),
        $borderBottomRightRadius = $element.find('input[name="border-bottom-right-radius"]'),
        // opacity
        $opacity = $element.find('input[name="opacity"]');

      // positioning
      const $position = $element.find('select[name="position"]');
      const $zIndex = $element.find('input[data-name="z-index"]');
      const $vGravity = $element.find('input[data-name="v-gravity"]');
      const $hGravity = $element.find('input[data-name="h-gravity"]');

      const $vOffset = $element.find('input[data-name="v-offset"]');
      const $hOffset = $element.find('input[data-name="h-offset"]');

      /*  let $width = $element.find('input[name="width"]');
       let $left = $element.find('input[name="left"]');
       let $right = $element.find('input[name="right"]');
       let $top = $element.find('input[name="top"]');
       let $bottom = $element.find('input[name="bottom"]'); */

      /* ------- UPDATE DESIGN OPTIONS VALUE --------- */
      $display.trigger('value-change');

      if (
        $targetElement.hasClass('module-wrap') ||
        $targetElement.hasClass('element-wrap') ||
        $targetElement.hasClass('gf_row') ||
        $targetElement.hasClass('gf_column')
      ) {
        // margin
        var marginTop = $targetElement.css('marginTop');
        var marginBottom = $targetElement.css('marginBottom');

        $marginTop.val(marginTop).attr('value', marginTop).trigger('value-change');
        $marginBottom.val(marginBottom).attr('value', marginBottom).trigger('value-change');

        if ($targetElement.hasClass('gf_row') || $targetElement.hasClass('gf_column')) {
          $marginRight.val('auto').attr('value', 'auto');
          $marginLeft.val('auto').attr('value', 'auto');
        } else {
          var marginRight = $targetElement.css('marginRight');
          var marginLeft = $targetElement.css('marginLeft');

          $marginRight.val(marginRight).attr('value', marginRight).trigger('value-change');
          $marginLeft.val(marginLeft).attr('value', marginLeft).trigger('value-change');
        }
      } else {
        let $wrapEM;
        if ($targetElement.closest('.element-wrap').length > 0) {
          $wrapEM = $targetElement.closest('.element-wrap');
        } else if ($targetElement.closest('.module-wrap').length > 0) {
          $wrapEM = $targetElement.closest('.module-wrap');
        }
        // hotfix margin (P) Image List
        if ($targetElement.hasClass('gf_product-image-thumb')) {
          $wrapEM = $targetElement;
        }
        if ($wrapEM != undefined) {
          // margin
          var marginTop = $wrapEM.css('marginTop');
          var marginBottom = $wrapEM.css('marginBottom');
          var marginRight = $wrapEM.css('marginRight');
          var marginLeft = $wrapEM.css('marginLeft');

          $marginTop.val(marginTop).attr('value', marginTop).trigger('value-change');
          $marginBottom.val(marginBottom).attr('value', marginBottom).trigger('value-change');
          $marginRight.val(marginRight).attr('value', marginRight).trigger('value-change');
          $marginLeft.val(marginLeft).attr('value', marginLeft).trigger('value-change');
        }
      }

      // Padding
      var $selfPadding;
      if (tgrClass == '' || $targetElement.hasClass(tgrClass)) {
        var $selfPadding = $targetElement;
      } else {
        var $selfPadding = $targetElement.find(tgrClass);
      }
      const paddingTop = $selfPadding.css('paddingTop');
      const paddingRight = $selfPadding.css('paddingRight');
      const paddingBottom = $selfPadding.css('paddingBottom');
      const paddingLeft = $selfPadding.css('paddingLeft');

      $paddingTop.val(paddingTop).attr('value', paddingTop).trigger('value-change');
      $paddingRight.val(paddingRight).attr('value', paddingRight).trigger('value-change');
      $paddingBottom.val(paddingBottom).attr('value', paddingBottom).trigger('value-change');
      $paddingLeft.val(paddingLeft).attr('value', paddingLeft).trigger('value-change');

      {
        const screenType =
          $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';
        let currentStyle;
        let $tempTargetElement = $targetElement;
        if ($targetElement.data('gfmodule') != undefined) {
          currentStyle = $targetElement.data('gfmodule').getModuleCSS();
        } else if ($targetElement.data('gfelement') != undefined) {
          currentStyle = $targetElement.data('gfelement').getElementCSS();
        } else if ($targetElement.data('gfrow') != undefined) {
          currentStyle = $targetElement.data('gfrow').getRowCSS();
        } else if ($targetElement.hasClass('gf_column')) {
          const colId = $targetElement.attr('data-id');
          currentStyle = $targetElement.parent().data('gfrow').getColCSS(colId);
          $tempTargetElement = $targetElemen.parent();
        } else {
          if ($targetElement.closest('.element-wrap').length > 0) {
            if ($targetElement.closest('.element-wrap').data('gfelement') != undefined) {
              currentStyle = $targetElement.closest('.element-wrap').data('gfelement').getElementCSS();
              $tempTargetElement = $targetElement.closest('.element-wrap');
            }
          } else if ($targetElement.closest('.module-wrap').length > 0) {
            if ($targetElement.closest('.module-wrap').data('gfmodule') != undefined) {
              currentStyle = $targetElement.closest('.module-wrap').data('gfmodule').getModuleCSS();
              $tempTargetElement = $targetElement.closest('.module-wrap');
            }
          }
        }
        // background
        {
          let $selfEMBackground;
          if (tgrClass == '' || $targetElement.hasClass(tgrClass)) {
            $selfEMBackground = $targetElement;
          } else {
            $selfEMBackground = $targetElement.find(tgrClass);
          }
          let bgColorVal = HELPER.getValueFromCSS($targetElement, currentStyle, 'background-color', screenType);
          if (!bgColorVal) {
            if ($selfEMBackground.css('background-color') != undefined) {
              bgColorVal = $selfEMBackground.css('background-color');
            } else {
              bgColorVal = '';
            }
          }
          $backgroundColor.val(bgColorVal).attr('value', bgColorVal).trigger('value-change');

          const bgImageVal = HELPER.getImageBg($selfEMBackground);
          $backgroundImage.val(bgImageVal).attr('value', bgImageVal).trigger('value-change');

          const backgroundSize = $selfEMBackground.css('background-size');
          let bgSizeVal = '';
          if (backgroundSize == 'cover') {
            bgSizeVal = 'cover';
          } else if (backgroundSize == 'contain') {
            bgSizeVal = 'contain';
          }
          $backgroundSize.val(bgSizeVal).attr('value', bgSizeVal).trigger('value-change');

          const bgRepeatVal = $selfEMBackground.css('background-repeat');
          $backgroundRepeat.val(bgRepeatVal).attr('value', bgRepeatVal).trigger('value-change');

          const bgPositionCss = $selfEMBackground.css('backgroundPosition');
          if (bgPositionCss != undefined) {
            const bgPositionArr = bgPositionCss.split(' ');
            var bgPositionVal1 = bgPositionArr[0];
            var bgPositionVal2 = bgPositionArr[1];
          } else {
            var bgPositionVal1 = '0%';
            var bgPositionVal2 = '0%';
          }

          const bgPositionVal = bgPositionVal1 + ' ' + bgPositionVal2;
          $backgroundPosition.val(bgPositionVal).attr('value', bgPositionVal).trigger('value-change');

          const bgAttachmentVal = $targetElement.css('background-attachment');
          $backgroundAttachment.val(bgAttachmentVal).attr('value', bgAttachmentVal).trigger('value-change');
        }
        // shadow
        {
          let $selfEMShadow;
          if (tgrClass == '' || $targetElement.hasClass(tgrClass)) {
            $selfEMShadow = $targetElement;
          } else {
            $selfEMShadow = $targetElement.find(tgrClass);
          }
          let shadowX = 0;
          let shadowY = 0;
          const shadowXY = shadowX + ',' + shadowY;
          let shadowBlur = 0;
          let shadowSpread = 0;
          let angle = 0;
          // Distance là cạnh huyền;
          let distance = 0;
          let shadowStyle = '';
          let shadowColorVal = '#333333';

          let cssBoxShadow = HELPER.getValueFromCSS($targetElement, currentStyle, 'box-shadow', screenType);
          if (!cssBoxShadow) {
            cssBoxShadow = $selfEMShadow.css('box-shadow');
          }
          if (cssBoxShadow) {
            const shadowType = cssBoxShadow.indexOf('inset') !== -1 ? 'inset' : 'outset';
            const regexCheckGSColor = /var\(--gf_gs-(.*)\)/;
            const matchValueCheckGSColor = cssBoxShadow.match(regexCheckGSColor);
            let shadowVal;
            if (matchValueCheckGSColor) {
              shadowColorVal = matchValueCheckGSColor[0];
              const shadowVal = cssBoxShadow.match(/-?(\d)+\.(\d+px)|(-?\d+px)/g);
              if (shadowVal != undefined && shadowVal.length > 0) {
                shadowX = shadowVal[0];
                shadowY = shadowVal[1];
                shadowBlur = shadowVal[2];
                shadowSpread = shadowVal[3];
                angle = Math.round(Math.atan2(parseInt(shadowY), parseInt(shadowX)) * (180 / Math.PI));
                if (angle < 0) angle = 360 + angle;
                // Distance là cạnh huyền;
                distance = Math.round(
                  Math.sqrt(parseInt(shadowX) * parseInt(shadowX) + parseInt(shadowY) * parseInt(shadowY)),
                );
                if (parseInt(shadowBlur) != 0 || parseInt(shadowSpread) != 0) {
                  shadowStyle = parseInt(distance) == 0 ? 'outer' : 'drop';
                }
              } else {
                if (parseInt(shadowBlur) != 0 || parseInt(shadowSpread) != 0) {
                  distance = Math.round(
                    Math.sqrt(parseInt(shadowX) * parseInt(shadowX) + parseInt(shadowY) * parseInt(shadowY)),
                  );
                  shadowStyle = parseInt(distance) == 0 ? 'outer' : 'drop';
                }
              }
            } else {
              cssBoxShadow = $selfEMShadow.css('box-shadow');
              const shadowVal = cssBoxShadow.match(/-?(\d)+\.(\d+px)|(-?\d+px)|(rgb\(.+\))|(rgba\(.+\))/g);
              if (shadowVal != undefined && shadowVal.length > 0) {
                shadowColorVal = shadowVal[0];
                shadowX = shadowVal[1];
                shadowY = shadowVal[2];
                shadowBlur = shadowVal[3];
                shadowSpread = shadowVal[4];
                angle = Math.round(Math.atan2(parseInt(shadowY), parseInt(shadowX)) * (180 / Math.PI));
                if (angle < 0) angle = 360 + angle;
                // Distance là cạnh huyền;
                distance = Math.round(
                  Math.sqrt(parseInt(shadowX) * parseInt(shadowX) + parseInt(shadowY) * parseInt(shadowY)),
                );
                if (parseInt(shadowBlur) != 0 || parseInt(shadowSpread) != 0) {
                  shadowStyle = parseInt(distance) == 0 ? 'outer' : 'drop';
                }
                shadowColorVal = HELPER.rgb2hex(shadowColorVal);
              } else {
                if (parseInt(shadowBlur) != 0 || parseInt(shadowSpread) != 0) {
                  distance = Math.round(
                    Math.sqrt(parseInt(shadowX) * parseInt(shadowX) + parseInt(shadowY) * parseInt(shadowY)),
                  );
                  shadowStyle = parseInt(distance) == 0 ? 'outer' : 'drop';
                }
              }
            }
            $boxShadowBlur.val(shadowBlur).attr('value', shadowBlur).trigger('value-change');
            $boxShadowAngle.val(angle).attr('value', angle).trigger('value-change');
            $boxShadowDistance.val(distance).attr('value', distance).trigger('value-change');
            $boxShadowSpread.val(shadowSpread).attr('value', shadowSpread).trigger('value-change');
            $boxShadowType.val(shadowType).attr('value', shadowType).trigger('value-change');
            $boxShadowStyle.val(shadowStyle).attr('value', shadowStyle).trigger('value-change');
            $boxShadowColor.val(shadowColorVal).attr('value', shadowColorVal).trigger('value-change');
          }
        }

        // border
        var $selfEMBorder;
        if (tgrClass == '' || $targetElement.hasClass(tgrClass)) {
          var $selfEMBorder = $targetElement;
        } else {
          var $selfEMBorder = $targetElement.find(tgrClass);
        }
        if ($selfEMBorder.css('border-top-width') != undefined) {
          var borderTopVal = $selfEMBorder.css('border-top-width');
        } else {
          var borderTopVal = 'auto';
        }
        $borderTop.val(borderTopVal).attr('value', borderTopVal).trigger('value-change');

        if ($selfEMBorder.css('border-right-width') != undefined) {
          var borderRightVal = $selfEMBorder.css('border-right-width');
        } else {
          var borderRightVal = 'auto';
        }
        $borderRight.val(borderRightVal).attr('value', borderRightVal).trigger('value-change');

        if ($selfEMBorder.css('border-bottom-width') != undefined) {
          var borderBottomVal = $selfEMBorder.css('border-bottom-width');
        } else {
          var borderBottomVal = 'auto';
        }
        $borderBottom.val(borderBottomVal).attr('value', borderBottomVal).trigger('value-change');

        if ($selfEMBorder.css('border-left-width') != undefined) {
          var borderLeftVal = $selfEMBorder.css('border-left-width');
        } else {
          var borderLeftVal = 'auto';
        }
        $borderLeft.val(borderLeftVal).attr('value', borderLeftVal).trigger('value-change');

        if ($selfEMBorder.css('border-style') != undefined) {
          var borderStyleVal = $selfEMBorder.css('border-style');
        } else {
          var borderStyleVal = '';
        }
        $borderStyle.val(borderStyleVal).attr('value', borderStyleVal).trigger('value-change');

        if (borderTopVal == borderLeftVal && borderTopVal == borderRightVal && borderTopVal == borderBottomVal) {
          $borderWidth.val(borderTopVal).attr('value', borderTopVal).trigger('value-change');
        } else {
          $borderWidth.val('auto').attr('value', 'auto').trigger('value-change');
        }

        let borderColorVal = HELPER.getValueFromCSS($targetElement, currentStyle, 'border-color', screenType);
        if (!borderColorVal) {
          if ($selfEMBorder.css('border-top-color') != undefined) {
            borderColorVal = $selfEMBorder.css('border-top-color');
          } else {
            borderColorVal = '';
          }
        }
        $borderColor.val(borderColorVal).attr('value', borderColorVal).trigger('value-change');

        if ($selfEMBorder.css('border-top-left-radius') != undefined) {
          var borderTopLeftRadiusVal = $selfEMBorder.css('border-top-left-radius');
        } else {
          var borderTopLeftRadiusVal = '';
        }
        $borderTopLeftRadius.val(borderTopLeftRadiusVal).attr('value', borderTopLeftRadiusVal).trigger('value-change');

        if ($selfEMBorder.css('border-top-right-radius') != undefined) {
          var borderTopRightRadiusVal = $selfEMBorder.css('border-top-right-radius');
        } else {
          var borderTopRightRadiusVal = '';
        }
        $borderTopRightRadius
          .val(borderTopRightRadiusVal)
          .attr('value', borderTopRightRadiusVal)
          .trigger('value-change');

        if ($selfEMBorder.css('border-bottom-left-radius') != undefined) {
          var borderBottomLeftRadiusVal = $selfEMBorder.css('border-bottom-left-radius');
        } else {
          var borderBottomLeftRadiusVal = '';
        }
        $borderBottomLeftRadius
          .val(borderBottomLeftRadiusVal)
          .attr('value', borderBottomLeftRadiusVal)
          .trigger('value-change');

        if ($selfEMBorder.css('border-bottom-right-radius') != undefined) {
          var borderBottomRightRadiusVal = $selfEMBorder.css('border-bottom-right-radius');
        } else {
          var borderBottomRightRadiusVal = '';
        }
        $borderBottomRightRadius
          .val(borderBottomRightRadiusVal)
          .attr('value', borderBottomRightRadiusVal)
          .trigger('value-change');

        if (
          borderTopLeftRadiusVal == borderTopRightRadiusVal &&
          borderTopLeftRadiusVal == borderBottomLeftRadiusVal &&
          borderTopLeftRadiusVal == borderBottomRightRadiusVal
        ) {
          $borderRadius.val(borderTopLeftRadiusVal).attr('value', borderTopVal).trigger('value-change');
        } else {
          $borderRadius.val('auto').attr('value', 'auto').trigger('value-change');
        }
      }

      // Opacity
      var $selfEMOpacity;
      if (tgrClass == '' || $targetElement.hasClass(tgrClass)) {
        var $selfEMOpacity = $targetElement;
      } else {
        var $selfEMOpacity = $targetElement.find(tgrClass);
      }
      if ($selfEMOpacity.css('opacity') != undefined) {
        var opacityVal = $selfEMOpacity.css('opacity');
      } else {
        var opacityVal = '1';
      }
      $opacity.val(opacityVal).attr('value', opacityVal).trigger('value-change');

      
      // Position
      {
        let $selfEMPosition, positionVal;
        if (tgrClass == '' || $targetElement.hasClass(tgrClass)) {
          $selfEMPosition = $targetElement;
        } else {
          $selfEMPosition = $targetElement.find(tgrClass);
        }
        if ($selfEMPosition.css('position') != undefined) {
          positionVal = $selfEMPosition.css('position');
        } else {
          positionVal = '';
        }
        $position.val(positionVal).attr('value', positionVal).trigger('value-change');
      }

      // Z-Index
      {
        let $selfEMZIndex, zIndexVal;
        if (tgrClass == '' || $targetElement.hasClass(tgrClass)) {
          $selfEMZIndex = $targetElement;
        } else {
          $selfEMZIndex = $targetElement.find(tgrClass);
        }
        if ($selfEMZIndex.css('zIndex') != undefined) {
          zIndexVal = $selfEMZIndex.css('zIndex');
        } else {
          zIndexVal = '';
        }
        $zIndex.val(zIndexVal).attr('value', zIndexVal).trigger('value-change');
      }

      let style;
      const screenType = $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';
      /**
       * Nếu không có top, bottom  => top
       * Nếu chỉ có bottom => bottom
       * Nếu có cả right cả left => left
       * Nếu không có left, right  => left
       * Nếu chỉ có right => right
       * Nếu có cả right cả left => left
       * Tương tự với Top
       * Nếu có
       */
      if (checkKeyValid('stickyAllScreenMode') && $position.val() == 'fixed') {
        if ($targetElement.data('gfmodule') != undefined) {
          style = $targetElement.data('gfmodule').getModuleCSS();
        } else if ($targetElement.data('gfelement') != undefined) {
          style = $targetElement.data('gfelement').getElementCSS();
        } else if ($targetElement.data('gfrow') != undefined) {
          style = $targetElement.data('gfrow').getRowCSS();
        } else if ($targetElement.hasClass('gf_column')) {
          const colId = $targetElement.attr('data-id');
          style = $targetElement.parent().data('gfrow').getColCSS(colId);
        } else {
          if ($targetElement.closest('.element-wrap').length > 0) {
            if ($targetElement.closest('.element-wrap').data('gfelement') != undefined) {
              style = $targetElement.closest('.element-wrap').data('gfelement').getElementCSS();
            }
          } else if ($targetElement.closest('.module-wrap').length > 0) {
            if ($targetElement.closest('.module-wrap').data('gfmodule') != undefined) {
              style = $targetElement.closest('.module-wrap').data('gfmodule').getModuleCSS();
            }
          }
        }
        // v-offset
        {
          let $selfEMTop, topVal;
          if (tgrClass == '' || $targetElement.hasClass(tgrClass)) {
            $selfEMTop = $targetElement;
          } else {
            $selfEMTop = $targetElement.find(tgrClass);
          }
  
          if ($selfEMTop.css('top') != undefined) {
            topVal = $selfEMTop.css('top');
          } else {
            topVal = '0px';
          }
          let topReal = HELPER.getValueFromCSS($targetElement, style, 'top', screenType);
          let bottomReal = HELPER.getValueFromCSS($targetElement, style, 'bottom', screenType);
          topReal = topReal == "unset" ? '' : topReal;
          bottomReal = bottomReal == "unset" ? '' : bottomReal;
          //nếu có bottom
          if (bottomReal && !topReal) {
            //set orientation bottom
            $vGravity.val('bottom').attr('value', 'bottom').trigger('value-change');
            $vOffset.val(bottomReal).attr('value', bottomReal).trigger('value-change');
          } else {
            $vGravity.val('top').attr('value', 'top').trigger('value-change');
            if (!topReal) {
              $vOffset.val( "0px").attr('value',  "0px").trigger('value-change');
            } else {
              $vOffset.val(topReal).attr('value', topReal).trigger('value-change');
            }
          }
        }

        // h-offset
        {
          let $selfEMTop, leftVal;
          if (tgrClass == '' || $targetElement.hasClass(tgrClass)) {
            $selfEMTop = $targetElement;
          } else {
            $selfEMTop = $targetElement.find(tgrClass);
          }

          if ($selfEMTop.css('left') != undefined) {
            leftVal = $selfEMTop.css('left');
          } else {
            leftVal = '0px';
          }
          let leftReal = HELPER.getValueFromCSS($targetElement, style, 'left', screenType);
          let rightReal = HELPER.getValueFromCSS($targetElement, style, 'right', screenType);
          leftReal = leftReal == "unset" ? '' : leftReal;
          rightReal = rightReal == "unset" ? '' : rightReal;
          //nếu có right
          if (rightReal && !leftReal) {
            //set orientation right
            $hGravity.val('right').attr('value', 'right').trigger('value-change');
            $hOffset.val(rightReal).attr('value', rightReal).trigger('value-change');
          } else {
            $hGravity.val('left').attr('value', 'left').trigger('value-change');
            if (!leftReal) {
              $hOffset.val("0px").attr('value', "0px").trigger('value-change');
            } else {
              $hOffset.val(leftReal).attr('value', leftReal).trigger('value-change');
            }
          }
        }
      } else {
        const elId = $targetElement?.get(0)?.id;
        if (elId && elId.startsWith('r-') && $targetElement.data('gfrow') != undefined) {
          style = $targetElement.data('gfrow').getRowCSS();
        } else if (elId && elId.startsWith('e-') && $targetElement.data('gfelement') != undefined) {
          style = $targetElement.data('gfelement').getElementCSS();
        } else if (elId && elId.startsWith('m-') && $targetElement.data('gfmodule') != undefined) {
          style = $targetElement.data('gfmodule').getModuleCSS();
        }
        // v-offset
        {
          let $selfEMTop, topVal;
          if (tgrClass == '' || $targetElement.hasClass(tgrClass)) {
            $selfEMTop = $targetElement;
          } else {
            $selfEMTop = $targetElement.find(tgrClass);
          }
  
          if ($selfEMTop.css('top') != undefined) {
            topVal = $selfEMTop.css('top');
          } else {
            topVal = '0px';
          }
          const topReal = HELPER.getValueFromCSS($targetElement, style, 'top', screenType);
          const bottomReal = HELPER.getValueFromCSS($targetElement, style, 'bottom', screenType);
  
          //nếu có bottom
          if (bottomReal && !topReal) {
            //set orientation bottom
            $vGravity.val('bottom').attr('value', 'bottom').trigger('value-change');
            $vOffset.val(bottomReal).attr('value', bottomReal).trigger('value-change');
          } else {
            $vGravity.val('top').attr('value', 'top').trigger('value-change');
            $vOffset.val(topVal).attr('value', topVal).trigger('value-change');
          }
        }
        
        // h-offset
        {
          let $selfEMTop, leftVal;
          if (tgrClass == '' || $targetElement.hasClass(tgrClass)) {
            $selfEMTop = $targetElement;
          } else {
            $selfEMTop = $targetElement.find(tgrClass);
          }

          if ($selfEMTop.css('left') != undefined) {
            leftVal = $selfEMTop.css('left');
          } else {
            leftVal = '0px';
          }
          const leftReal = HELPER.getValueFromCSS($targetElement, style, 'left', screenType);
          const rightReal = HELPER.getValueFromCSS($targetElement, style, 'right', screenType);

          //nếu có right
          if (rightReal && !leftReal) {
            //set orientation right
            $hGravity.val('right').attr('value', 'right').trigger('value-change');
            $hOffset.val(rightReal).attr('value', rightReal).trigger('value-change');
          } else {
            $hGravity.val('left').attr('value', 'left').trigger('value-change');
            $hOffset.val(leftVal).attr('value', leftVal).trigger('value-change');
          }
        }
      }

      _this.initGlobalStyle();
      return false;
    };

    this.getDesignOptionsByAttr = function (attr, value) {
      let deOptions = [];
      switch (attr) {
        case 'margin-left':
        case 'margin-right':
          if ($targetElement.hasClass('gf_row') || $targetElement.hasClass('gf_column')) {
            deOptions = [
              {
                key: attr,
                value: 'auto',
              },
            ];
          } else {
            deOptions = [
              {
                key: attr,
                value: value,
              },
            ];
          }
          break;

        case 'background-image':
          deOptions = [
            {
              key: attr,
              value: HELPER.getImageBgOption(value),
            },
          ];
          break;

        default:
          deOptions = [
            {
              key: attr,
              value: value,
            },
          ];
          break;
      }
      return deOptions;
    };

    /**
     * Nếu chọn căn theo top thì reset bottom và ngược lại
     * Nếu chọn căn theo left thì reset right và ngược lại
     */
    this.supportGravity = function (style, attr, value, $self, screenType) {
      const devices = ['xs', 'sm', 'md', 'lg'];
      let customDEOptions = [];
      let resetKey;
      //reset
      if (attr == 'top') {
        resetKey = 'bottom';
      }
      if (attr == 'bottom') {
        resetKey = 'top';
      }

      if (attr == 'left') {
        resetKey = 'right';
      }
      if (attr == 'right') {
        resetKey = 'left';
      }
      const $designOptions = $("#md-settings").find('.design-options');
      const valPosition = $designOptions.find("#position").val();
      if (checkKeyValid('stickyAllScreenMode') && valPosition == 'fixed') {
        customDEOptions = [
          {
            key: attr,
            value: value,
          },
          {
            key: resetKey,
            value: 'unset',
          },
        ];
        style = HELPER.designOptions2Style($self, screenType, style, customDEOptions);
      } else {
        customDEOptions = [
          {
            key: attr,
            value: value,
          },
          {
            key: resetKey,
            value: '',
          },
        ];
        // apply cho tất cả màn hình
        for (let i = 0; i < devices.length; i++) {
          style = HELPER.designOptions2Style($self, devices[i], style, customDEOptions);
        }
      }
      return style;
    };
    this.supportPosition = function (style, attr, value, $self, label) {
      const devices = ['xs', 'sm', 'md', 'lg'];
      let customDEOptions = [];
      //force update z-index và top left khi fixed
      /**
       * Bình thường thì cần trigger input-change tuy nhiên để tối ưu và chỉ sửa css trong 1 lần
       * Nên sửa giá trị ở sidebar rồi thay thế luôn vào style. Tránh CSS phải render quá nhiều lần. Cần update new flow trong khi làm sidebar
       */
      const $zIndex = $designOptions.find('#z-index');
      const $vGravity = $designOptions.find('#v-gravity');
      const $hGravity = $designOptions.find('#h-gravity');
      const $vOLeft = $designOptions.find('#v-offset');
      const $hOLeft = $designOptions.find('#h-offset');

      let newZIndex = 99;
      let newVG = 'top';
      let newHG = 'left';
      let newVOffset = '0';
      let newHOffset = '0';

      if (value == 'fixed') {
        newZIndex = 99;
        newVG = 'top';
        newHG = 'left';
        newVOffset = '0';
        newHOffset = '0';
      } else {
        newZIndex = 1;
        newVG = 'top';
        newHG = 'left';
        newVOffset = '';
        newHOffset = '';
      }

      //change input value sidebar
      $zIndex.data('gfinputfield').setValue(newZIndex);
      $vGravity.data('gfgravity').setValue(newVG);
      $hGravity.data('gfgravity').setValue(newHG);
      $vOLeft.data('gfinputfield').setValue(newVOffset);
      $hOLeft.data('gfinputfield').setValue(newHOffset);

      customDEOptions = [
        {
          key: attr,
          value: value,
        },
        {
          key: 'z-index',
          value: newZIndex,
        },
        {
          key: 'top',
          value: newVOffset,
        },
        {
          key: 'bottom',
          value: '',
        },
        {
          key: 'left',
          value: newHOffset,
        },
        {
          key: 'right',
          value: '',
        },
      ];
      //apply cho tất cả màn hình
      for (var i = 0; i < devices.length; i++) {
        style = HELPER.designOptions2Style($self, devices[i], style, customDEOptions);
      }

      /**
       * Nếu là ROW và position mới là fixed thì thêm style để reset margin-left khi full width
       */
      if (label == 'Row') {
        //apply cho tất cả màn hình
        for (var i = 0; i < devices.length; i++) {
          if (value == 'fixed') {
            style = HELPER.setValueFromCSS(
              $self,
              style,
              'margin-left',
              'unset',
              devices[i],
              '.gf_row.gf_row-fluid.gf_position-fixed',
              true,
            );
            style = HELPER.setValueFromCSS(
              $self,
              style,
              'width',
              '100%',
              devices[i],
              '.gf_row.gf_row-fluid.gf_position-fixed',
              true,
            );
            style = HELPER.setValueFromCSS(
              $self,
              style,
              'max-width',
              'none',
              devices[i],
              '.gf_row.gf_row-fluid.gf_position-fixed',
              true,
            );
          } else {
            style = HELPER.setValueFromCSS(
              $self,
              style,
              'margin-left',
              '',
              devices[i],
              '.gf_row.gf_row-fluid.gf_position-fixed',
              true,
            );
            style = HELPER.setValueFromCSS(
              $self,
              style,
              'width',
              '',
              devices[i],
              '.gf_row.gf_row-fluid.gf_position-fixed',
              true,
            );
            style = HELPER.setValueFromCSS(
              $self,
              style,
              'max-width',
              '',
              devices[i],
              '.gf_row.gf_row-fluid.gf_position-fixed',
              true,
            );
          }
        }
      }
      return style;
    };
    this.init();
  };

  jQuery.fn.gfTabs = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gftabs')) {
        const plugin = new jQuery.gfTabs(this, options);
        jQuery(this).data('gftabs', plugin);
      }
    });
  };
})(jQuery);
